import { Component, OnInit } from '@angular/core';
import { AreaZoneService } from '../../../services/area-zone.service'
import { DynamicDialogRef } from 'primeng/api';

@Component({
  selector: 'app-search-areazone',
  templateUrl: './search-areazone.component.html',
  styleUrls: ['./search-areazone.component.css']
})
export class SearchAreazoneComponent implements OnInit {

  constructor(
    private AreaZoneService: AreaZoneService,
    public ref: DynamicDialogRef,
  ) { }

  loading: boolean;
  listItem: any [];

  ngOnInit() {
    this.loading = true;
    this.onLoadProdicts();
  }

  onLoadProdicts(){
    this.AreaZoneService.GetAreaZone().then( 
      zone => {
      this.listItem = zone;
      this.loading = false;
    }); 
  }

  onSelect(items){
    this.ref.close(items);
  }

  onSelectdbc(items){
    this.ref.close(items);
  }

}
